/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'list': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="currentColor" d="M4 1.505C4 1.226 4.229 1 4.5 1h11c.276 0 .5.214.5.505v.99a.506.506 0 01-.5.505h-11a.495.495 0 01-.5-.505v-.99zm-4 0C0 1.226.214 1 .505 1h.99c.279 0 .505.214.505.505v.99A.497.497 0 011.495 3h-.99A.497.497 0 010 2.495v-.99zm4 4C4 5.226 4.229 5 4.5 5h11c.276 0 .5.214.5.505v.99a.506.506 0 01-.5.505h-11a.495.495 0 01-.5-.505v-.99zm-4 0C0 5.226.214 5 .505 5h.99c.279 0 .505.214.505.505v.99A.497.497 0 011.495 7h-.99A.497.497 0 010 6.495v-.99zm4 4C4 9.226 4.229 9 4.5 9h11c.276 0 .5.214.5.505v.99a.506.506 0 01-.5.505h-11a.495.495 0 01-.5-.505v-.99zm-4 0C0 9.226.214 9 .505 9h.99c.279 0 .505.214.505.505v.99a.497.497 0 01-.505.505h-.99A.497.497 0 010 10.495v-.99zm4 4c0-.279.229-.505.5-.505h11c.276 0 .5.214.5.505v.99a.506.506 0 01-.5.505h-11a.495.495 0 01-.5-.505v-.99zm-4 0C0 13.226.214 13 .505 13h.99c.279 0 .505.214.505.505v.99a.497.497 0 01-.505.505h-.99A.497.497 0 010 14.495v-.99z"/>'
  }
})
